module.exports = __webpack_public_path__ + "img/Ridder iQ Logo wit.43294b8e.svg";